import { SRM } from '@/shared/config/routes';

import type { AppSearchAction } from './types';

/** Pages that must not receive `?search` — the param opens the wrong UI there. */
export const PAGES_WITHOUT_SEARCH_PARAM: readonly string[] = [SRM];

const disabledPages = new Set(PAGES_WITHOUT_SEARCH_PARAM);

export const pageFromHref = (href?: string) => {
  if (!href) {
    return undefined;
  }

  try {
    return (
      new URL(href, 'http://app.local').pathname.replace(/\/+$/, '') || '/'
    );
  } catch {
    return href.split('?')[0] || undefined;
  }
};

export const isSearchParamEnabledForPage = (page?: string | null) => {
  if (!page) {
    return true;
  }

  return !disabledPages.has(pageFromHref(page) ?? page);
};

export const isSearchParamEnabledForAction = (action: AppSearchAction) =>
  isSearchParamEnabledForPage(
    pageFromHref(action.href) ?? pageFromHref(action.searchHref) ?? action.to,
  );

export const hasSearchCommitActions = (actions: AppSearchAction[]) =>
  actions.some(
    (action) =>
      Boolean(action.searchHref) && isSearchParamEnabledForAction(action),
  );